module.exports = __webpack_public_path__ + "static/media/ppt.5e6ba80a.svg";